import React, { useEffect, useRef, useState } from "react";
import {
  IconCloseSmall,
  IconCloseSmallBlue,
  IconDoorBack,
  IconDoorBackBlue,
  IconKeyboardArrowRight,
  IconKeyboardArrowRightBlue,
  IconKeyboardArrowLeftBlue,
  IconMoreHoriz,
  IconMoreHorizBlue,
} from "assets/svg";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { cleanData } from "reducers/authSlice";
import { menuAdmin } from "./MenuAdmin";
import { useCommonContext } from "contexts/CommonContext";
import { MenuStatusEnum } from "common/enums/MenuStatus.enum";

const HeaderTopAdmin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [openMenuBox, setOpenMenuBox] = useState(false);
  const { userData } = useSelector((state: RootState) => state.auth);
  const { headerTitle, openMenuBoxMobile, setOpenMenuBoxMobile } =
    useCommonContext();

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpenMenuBox(false);
        setOpenMenuBoxMobile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logout = () => {
    dispatch(cleanData());
    navigate("/admin");
  };

  return (
    <div
      ref={ref}
      className="flex w-full h-[50px] md:h-[80px] px-[8px] py-[8px] pl-[8px] md:px-[15px] md:py-[15px] md:pl-[40px] justify-end items-center gap-[10px] md:gap-[20px] border-b border-b-primary bg-white relative rounded-t-[12px]"
    >
      <div
        className="md:hidden flex w-[34px] h-[34px] p-[10px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary-light"
        onClick={() => navigate(-1)}
      >
        <IconKeyboardArrowLeftBlue className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
      </div>
      {/*Title*/}
      <div className="min-w-0 flex-[1_0_0] truncate whitespace-nowrap text-center font-['Noto_Sans_JP'] text-[18px] font-bold not-italic leading-[160%] text-black md:overflow-visible md:whitespace-normal md:text-left md:text-[28px]">
        {headerTitle}
      </div>
      {/*Account*/}
      <div className="hidden md:flex items-center gap-[10px]">
        <div className="text-black text-center font-['Noto Sans JP'] text-[14px] not-italic font-normal leading-[160%]">
          {userData.name}
        </div>
        <div
          className="flex w-[34px] h-[34px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary-light"
          onClick={() => setOpenMenuBox(!openMenuBox)}
        >
          {openMenuBox ? (
            <IconCloseSmallBlue className="w-[24px] h-[24px] aspect-[1/1]" />
          ) : (
            <IconMoreHorizBlue className="w-[24px] h-[24px] aspect-[1/1]" />
          )}
        </div>
      </div>

      {/*Menu (Mobile)*/}
      <div
        className="md:hidden flex w-[34px] h-[34px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary"
        onClick={() => setOpenMenuBoxMobile(!openMenuBoxMobile)}
      >
        <IconMoreHoriz className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
      </div>
      {/*Menu Box*/}
      {openMenuBox && (
        <div className="hidden md:flex w-[200px] px-[20px] py-[10px] flex-col justify-center items-center absolute right-[16px] bottom-[-50px] rounded-[14px] bg-primary-light z-[9]">
          {/*Nav Item*/}
          <div className="h-[41px] flex py-[10px] items-center gap-[5px] self-stretch">
            <IconDoorBackBlue className="w-[20px] h-[20px] aspect-[1/1]" />
            <div
              onClick={logout}
              className="h-[21px] flex-[1_0_0] text-primary font-['Noto Sans JP'] text-[13px] not-italic font-bold leading-[160%] cursor-pointer"
            >
              ログアウト
            </div>
            <IconKeyboardArrowRightBlue className="w-[20px] h-[20px] aspect-[1/1]" />
          </div>
        </div>
      )}
      {/*Menu Box (Mobile)*/}
      {openMenuBoxMobile && (
        <div className="md:hidden w-full flex pb-[20px] flex-col items-end gap-[5px] absolute left-0 top-0 rounded-b-[12px] bg-primary z-[99]">
          {/*Menu HeaderTop*/}
          <div className="flex h-[50px] p-[8px] justify-center items-center gap-[10px] self-stretch">
            <div className="flex w-[34px] h-[34px] p-[10px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary"></div>
            {/*Title*/}
            <div className="flex-[1_0_0] text-white text-center font-['Noto Sans JP'] text-[18px] not-italic font-bold leading-[160%]">
              メニュー
            </div>
            {/*Menu*/}
            <div
              className="md:hidden flex w-[34px] h-[34px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-[#103E75]"
              onClick={() => setOpenMenuBoxMobile(false)}
            >
              <IconCloseSmall className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
            </div>
          </div>
          {/*Menu Contents*/}
          <div className="flex px-[15px] flex-col items-start gap-[15px] self-stretch">
            {/*Sp Nav*/}
            <div className="flex w-full flex-col items-start border-t border-primary-medium">
              {menuAdmin.map((item) =>
                item.status === MenuStatusEnum.ENABLED ? (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className="flex min-h-[50px] py-[10px] items-center gap-[10px] self-stretch border-b border-primary-medium bg-primary"
                  >
                    <div className="w-[24px] h-[24px] aspect-[1/1]">
                      {item.icon}
                    </div>
                    <div className="flex-[1_0_0] text-white font-['Noto Sans JP'] text-[14px] not-italic font-bold leading-[160%]">
                      {item.label}
                    </div>
                    <IconKeyboardArrowRight className="w-[20px] h-[20px] aspect-[1/1]" />
                  </NavLink>
                ) : (
                  <div
                    key={item.to}
                    className="flex min-h-[50px] py-[10px] items-center gap-[10px] self-stretch border-b border-primary-medium bg-primary text-white opacity-[0.5]"
                  >
                    <div className="w-[24px] h-[24px] aspect-[1/1]">
                      {item.icon}
                    </div>
                    <div className="flex-[1_0_0] text-white font-['Noto Sans JP'] text-[14px] not-italic font-bold leading-[160%]">
                      {item.label}
                    </div>
                    <IconKeyboardArrowRight className="w-[20px] h-[20px] aspect-[1/1]" />
                  </div>
                ),
              )}
            </div>
            {/*Button Wrap*/}
            <div className="flex px-5 flex-col items-start gap-[10px] self-stretch">
              <div
                className="flex h-10 justify-center items-center gap-[5px] self-stretch rounded-[6px] bg-[#103E75]"
                onClick={logout}
              >
                <IconDoorBack className="w-[20px] h-[20px] aspect-[1/1]" />
                <div className="text-[12px] font-normal leading-[160%] text-white font-['Noto Sans JP'] cursor-pointer">
                  ログアウト
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderTopAdmin;
